import { styled } from '@mui/system'
import { Grid } from '@mui/material'

const Root = styled(Grid)`
	.MuiGrid-item {
		.prev-link {
			margin-left: -9px;
		}
		.next-link {
			margin-right: -9px;
		}
		.prev-link,
		.next-link {
			display: flex;
			align-items: center;
			gap: ${({ theme }) => theme.spacing(1)};
		}
	}
`

export { Root }
